import { Subject } from 'rxjs';

export enum DiagramContextMenuEventType {
    nodeAdd,
    nodeMove,
    resetWidth,
    automationAdd,
    automationMove
}

export enum DiagramContextMenuActionType {
    CloseMenu,
    LoadData
}

export class DiagramContextMenu {
    actions$: Subject<any>;
    events$: Subject<{ type: DiagramContextMenuEventType, payload: any }>;
    constructor() {
        this.events$ = new Subject();
        this.actions$ = new Subject();
    }
}

export class TaskMenuItem {
    id: string;
    guid: string;
    name: string;
    enable: boolean;

    constructor(id: string, guid: string, name: string) {
        this.id = id;
        this.guid = guid;
        this.name = name;
        this.enable = true;
    }
}

export enum AutomationActionType {
    CreateANote,
    CreateASidenote,
    CreateRelationships,
    UpdateANote,
    CreateAnEntity,
    UpdateAnEntity
}
